import React from 'react'
import { Route, Redirect } from 'react-router'
import Loadable from 'react-loadable'
import loading from 'components/ui/Loader/Loader'

const PageLayout  = Loadable({ loader: () => import('voting/containers/PageLayout/PageLayout'), loading })

const HomePage    = Loadable({ loader: () => import('layers/emergency-alert/pages/HomePage/HomePage'), loading })


export default (links) => (
  <Route>
    <Route component={PageLayout}>
      <Route path={links.root} component={HomePage} />
      <Redirect path={`${links.root}/*`} to={links.root} />
    </Route>
  </Route>
)
